import { graphql } from "gatsby";
import * as React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import { Container } from '../components/styles';
import DocsSidebar from '../components/DocsSidebar';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  p {
    font-size : 15px;
  }
`;

const SideBySide = styled.div`
  display : flex;
  flex-direction : row;
`;

export default function BlogPostTemplate({ data: { markdownRemark } }) {
  const { frontmatter, html } = markdownRemark;

  return (
      <Container>
        <Layout>
          <Seo title={frontmatter.title} />
          {
            parseInt(frontmatter.hasSidebar) > 0 ?
            <SideBySide>
              <DocsSidebar/>
              <div>
                <h1>{frontmatter.title}</h1>
                <p style={{fontSize : '12px'}}>Last updated: {frontmatter.date}</p>
                <Wrapper className="post-body" dangerouslySetInnerHTML={{ __html: html }} />
              </div>
            </SideBySide> :
            <>
              <h1>{frontmatter.title}</h1>
              <p>Last updated: {frontmatter.date}</p>
              <Wrapper className="post-body" dangerouslySetInnerHTML={{ __html: html }} />
            </>
          }
        </Layout>
      </Container>
  );
}

export const pageQuery = graphql`
  query ($id: String!) {
    markdownRemark(id: { eq: $id }) {
      headings {
        value
      }
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        hasSidebar
      }
    }
  }
`;